/* eslint-disable no-restricted-globals */
/* eslint-disable react/button-has-type */
/* eslint-disable no-restricted-imports */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react';

import { Col, Row, PrimaryButton, InverseButton, Popper } from '@crehana/ui';

import CrehanaLogo from '@crehana/icons/dist/CrehanaLogo';
import PadLock1 from '@crehana/icons/dist/PadLock1';

import { useAmplitude, getSourceEventParams } from '@crehana/analytics';

import { useTranslation } from '@crehana/i18n';

import PromotionMessage from 'Jsx/CheckoutV4/components/PromotionMessage';
import { ItemType } from 'Jsx/CheckoutV4/types/types';

import { AMPLITUDE_EVENTS } from 'Jsx/CheckoutV4/common/constants';

const Header = ({
  displayTimer,
  finished,
  isValidDuringCall,
  itemType,
}: {
  displayTimer?: string;
  finished?: boolean;
  isValidDuringCall?: boolean;
  itemType?: ItemType;
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const shareRef = React.useRef(null);
  const { logEvent } = useAmplitude();

  const registerAmplitudeLogoClick = (buttonLabel: string) => {
    logEvent({
      event: 'Click Checkout Logo',
      data: {
        'Button Label': buttonLabel,
        'Item Type': itemType,
        ...getSourceEventParams(),
      },
    });
  };
  const goBack = () => {
    registerAmplitudeLogoClick(AMPLITUDE_EVENTS.LabelOne);
    if (document.referrer === '') {
      window.location.href = '/';
    } else {
      history.back();
    }
  };

  return (
    <header className="p-16 bg-primary-dark">
      <div
        className="flex items-center justify-between ml-auto mr-auto px-48 lg:px-0"
        style={{ maxWidth: 1152 }}
      >
        <button type="button" ref={shareRef} onClick={() => setOpen(true)}>
          <CrehanaLogo
            ignoreColor
            className="fill-current text-white"
            size={20}
          />
        </button>
        <Popper
          className="p-24"
          anchorRef={shareRef}
          isVisible={open}
          dismissOnClickOutside
          onDismiss={() => setOpen(false)}
          position="bottom"
          arrowProps={{
            triggerPosition: 'center',
            visible: true,
          }}
        >
          <div className="w-full text-center">
            <p className="pb-8 font-body3">{t('LABEL_HEADER_CHECKOUT')}</p>
            <Row>
              <Col xs={6} sm={6} lg={6}>
                <InverseButton
                  onClick={goBack}
                  label={t('BUTTON_LABEL_HEADER_CHECKOUT_1')}
                />
              </Col>
              <Col xs={6} sm={6} lg={6}>
                <PrimaryButton
                  onClick={() => {
                    registerAmplitudeLogoClick(AMPLITUDE_EVENTS.LabeLTwo);
                    setOpen(false);
                  }}
                  label={t('BUTTON_LABEL_HEADER_CHECKOUT_2')}
                />
              </Col>
            </Row>
          </div>
        </Popper>

        {!finished && displayTimer && !isValidDuringCall && (
          <p className="hidden text-center sm:block font-button text-yellow-light">
            {t('TIMER_LABEL')}
            <span className="ml-4">{displayTimer}</span>
          </p>
        )}
        {isValidDuringCall && (
          <PromotionMessage
            message={t('PROMOTION_MESSAGE')}
            className="hidden bg-transparent md:block"
          />
        )}

        <div className="flex items-center">
          <p>
            <PadLock1
              ignoreColor
              size={13}
              className="fill-current text-white mr-8"
            />
          </p>
          <div className="text-white font-link">{t('SAFE_LABEL')}</div>
        </div>
      </div>
    </header>
  );
};

export default Header;
